
<p-confirmDialog />

<div class="card">
  <div class="card-content">
    <!-- Stats cards row (same structure as Allocation page) -->
    <div class="stats-cards-row">
      <div class="stats-card stats-card--total"
        pTooltip="Counts employees that have a Forecast row for {{ selectedYear }} (respecting the 'Exclude from forecast' employee flag). This is why it can differ from Monthly Allocation — employees not yet added to the Forecast grid are shown separately under 'Un-Forecasted'."
        tooltipPosition="top">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ forecastTotalCount }}</span>
          <span class="stats-card-label">Total Employees</span>
          <span class="stats-card-sublabel">With a forecast this year</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-users"></i></div>
      </div>
      <div class="stats-card stats-card--fully-allocated">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ forecastConfirmedCount }}</span>
          <span class="stats-card-label">Have Confirmed</span>
          <span class="stats-card-sublabel">{{ forecastConfirmedPercent }}% of employees</span>
          <div class="stats-card-progress">
            <div class="stats-card-progress-fill" [style.width.%]="forecastConfirmedPercent"></div>
          </div>
        </div>
        <div class="stats-card-icon"><i class="pi pi-check-circle"></i></div>
      </div>
      <div class="stats-card stats-card--over-allocated">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ forecastTotalCount - forecastConfirmedCount }}</span>
          <span class="stats-card-label">Planned Only</span>
          <span class="stats-card-sublabel">No confirmed months yet</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-clock"></i></div>
      </div>
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ forecastUniqueProjectCount }}</span>
          <span class="stats-card-label">Unique Projects</span>
          <span class="stats-card-sublabel">Assigned this year</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-briefcase"></i></div>
      </div>
    </div>

    <!-- Action bar: same structure as Allocation (left = actions, right = search + primary) -->
    <div class="controls-section sticky-controls mb-4">
      <div class="controls-left">
        <p-button
          *ngIf="canExport"
          label="Export Excel"
          icon="pi pi-file-excel"
          (onClick)="exportToExcel()"
          severity="success"
          styleClass="btn-export-excel"
          [disabled]="filteredForecasts.length === 0" />
        <p-button
          *ngIf="canWrite"
          label="Copy to Next Year"
          icon="pi pi-copy"
          (onClick)="copyToNextYear()"
          severity="secondary"
          styleClass="btn-copy-action" />
        <p-button
          [label]="'Un-Forecasted (' + unforecastedCount + ')'"
          icon="pi pi-eye"
          (onClick)="showUnforecastedDialog()"
          severity="secondary"
          styleClass="btn-unallocated"
          pTooltip="Eligible employees (active, not excluded from forecast) who have no forecast row for this year yet"
          tooltipPosition="top" />
      </div>
      <div class="page-header-actions-right">
        <div class="page-header-search">
          <div class="search-box">
            <i class="pi pi-search"></i>
            <input
              pInputText
              id="search"
              [(ngModel)]="searchText"
              (input)="onSearch()"
              placeholder="Search employee, designation, category, project..."
              class="search-input" />
            <p-button
              *ngIf="searchText"
              icon="pi pi-times"
              (onClick)="clearSearch()"
              [text]="true"
              severity="secondary"
              size="small"
              styleClass="search-clear-btn" />
          </div>
        </div>
        <p-button
          *ngIf="canWrite"
          label="Add Forecast"
          icon="pi pi-plus"
          (onClick)="showAddDialog()"
          severity="primary" />
      </div>
    </div>

    <!-- Filter bar: Year is in main app header -->
    <div class="filter-bar filter-bar-collapsible mb-4" [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label for="designationFilter" class="filter-label">Designation</label>
          <p-multiSelect
            id="designationFilter"
            [(ngModel)]="selectedDesignations"
            (ngModelChange)="applyFilters()"
            [options]="designationOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="All Designations"
            display="chip"
            [showToggleAll]="true"
            [filter]="true"
            panelStyleClass="filter-dropdown-panel"
            appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="categoryFilter" class="filter-label">Category</label>
          <p-multiSelect
            id="categoryFilter"
            [(ngModel)]="selectedCategories"
            (ngModelChange)="applyFilters()"
            [options]="categoryOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="All Categories"
            display="chip"
            [showToggleAll]="true"
            [filter]="true"
            panelStyleClass="filter-dropdown-panel"
            appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="projectFilter" class="filter-label">Project</label>
          <p-multiSelect
            id="projectFilter"
            [(ngModel)]="selectedProjects"
            (ngModelChange)="applyFilters()"
            [options]="projectOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="All projects"
            display="chip"
            [showToggleAll]="true"
            [filter]="true"
            panelStyleClass="filter-dropdown-panel"
            appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="serviceGroupFilter" class="filter-label">Service Group</label>
          <p-multiSelect
            id="serviceGroupFilter"
            [(ngModel)]="selectedServiceGroups"
            (ngModelChange)="applyFilters()"
            [options]="serviceGroupOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="All service groups"
            display="chip"
            [showToggleAll]="true"
            [filter]="true"
            panelStyleClass="filter-dropdown-panel"
            appendTo="body" />
        </div>
      </div>
      <div class="filter-bar-actions" *ngIf="hasActiveFilters()">
        <button type="button" class="btn-clear-filters" (click)="clearFilters()" title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>
    </div>

  <p-table
    [scrollable]="true" scrollHeight="flex"
    [value]="filteredForecasts"
    [loading]="loading"
    [tableStyle]="{ 'width': '100%' }"
    styleClass="forecast-table table-flat table-no-xscroll">

    <ng-template pTemplate="header">
      <tr>
        <th style="width: 34px">#</th>
        <th class="forecast-col-employee" pSortableColumn="employeeName">
          Employee
          <p-sortIcon field="employeeName" />
        </th>
        <th>Jan</th>
        <th>Feb</th>
        <th>Mar</th>
        <th>Apr</th>
        <th>May</th>
        <th>Jun</th>
        <th>Jul</th>
        <th>Aug</th>
        <th>Sep</th>
        <th>Oct</th>
        <th>Nov</th>
        <th>Dec</th>
        <th *ngIf="canWrite" class="col-actions allocation-col-actions" style="width: 6.5rem">Actions</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-forecast let-rowIndex="rowIndex">
      <tr>
        <td class="text-center">{{ rowIndex + 1 }}</td>
        <td class="forecast-cell-employee">
          <div class="table-employee-wrap table-cell-hover" [pTooltip]="getEmployeeTooltip(forecast)" tooltipPosition="top">
            <span class="table-employee-avatar" [title]="forecast.employeeName">{{ getEmployeeInitials(forecast.employeeName) }}</span>
            <div class="table-employee-info">
              <span class="table-employee-name">{{ forecast.employeeName }}</span>
              <span class="table-employee-role">{{ getEmployeeMeta(forecast) }}</span>
            </div>
          </div>
        </td>
        <td [ngClass]="{'status-confirmed': forecast.janStatus === 2, 'status-planned': forecast.janStatus === 1, 'available-cell': isAvailable(forecast.janProjectName)}">
          <span [class.available-cell]="isAvailable(forecast.janProjectName)" title="{{ forecast.janProjectName || '-' }}">{{ forecast.janProjectName || '-' }}<span class="presales-chip" *ngIf="isPresalesProject(forecast.janProjectId)" pTooltip="In-pursuit presales deal — not yet won" tooltipPosition="top">Presales</span></span>
        </td>
        <td [ngClass]="{'status-confirmed': forecast.febStatus === 2, 'status-planned': forecast.febStatus === 1, 'available-cell': isAvailable(forecast.febProjectName)}">
          <span [class.available-cell]="isAvailable(forecast.febProjectName)" title="{{ forecast.febProjectName || '-' }}">{{ forecast.febProjectName || '-' }}<span class="presales-chip" *ngIf="isPresalesProject(forecast.febProjectId)" pTooltip="In-pursuit presales deal — not yet won" tooltipPosition="top">Presales</span></span>
        </td>
        <td [ngClass]="{'status-confirmed': forecast.marStatus === 2, 'status-planned': forecast.marStatus === 1, 'available-cell': isAvailable(forecast.marProjectName)}">
          <span [class.available-cell]="isAvailable(forecast.marProjectName)" title="{{ forecast.marProjectName || '-' }}">{{ forecast.marProjectName || '-' }}<span class="presales-chip" *ngIf="isPresalesProject(forecast.marProjectId)" pTooltip="In-pursuit presales deal — not yet won" tooltipPosition="top">Presales</span></span>
        </td>
        <td [ngClass]="{'status-confirmed': forecast.aprStatus === 2, 'status-planned': forecast.aprStatus === 1, 'available-cell': isAvailable(forecast.aprProjectName)}">
          <span [class.available-cell]="isAvailable(forecast.aprProjectName)" title="{{ forecast.aprProjectName || '-' }}">{{ forecast.aprProjectName || '-' }}<span class="presales-chip" *ngIf="isPresalesProject(forecast.aprProjectId)" pTooltip="In-pursuit presales deal — not yet won" tooltipPosition="top">Presales</span></span>
        </td>
        <td [ngClass]="{'status-confirmed': forecast.mayStatus === 2, 'status-planned': forecast.mayStatus === 1, 'available-cell': isAvailable(forecast.mayProjectName)}">
          <span [class.available-cell]="isAvailable(forecast.mayProjectName)" title="{{ forecast.mayProjectName || '-' }}">{{ forecast.mayProjectName || '-' }}<span class="presales-chip" *ngIf="isPresalesProject(forecast.mayProjectId)" pTooltip="In-pursuit presales deal — not yet won" tooltipPosition="top">Presales</span></span>
        </td>
        <td [ngClass]="{'status-confirmed': forecast.junStatus === 2, 'status-planned': forecast.junStatus === 1, 'available-cell': isAvailable(forecast.junProjectName)}">
          <span [class.available-cell]="isAvailable(forecast.junProjectName)" title="{{ forecast.junProjectName || '-' }}">{{ forecast.junProjectName || '-' }}<span class="presales-chip" *ngIf="isPresalesProject(forecast.junProjectId)" pTooltip="In-pursuit presales deal — not yet won" tooltipPosition="top">Presales</span></span>
        </td>
        <td [ngClass]="{'status-confirmed': forecast.julStatus === 2, 'status-planned': forecast.julStatus === 1, 'available-cell': isAvailable(forecast.julProjectName)}">
          <span [class.available-cell]="isAvailable(forecast.julProjectName)" title="{{ forecast.julProjectName || '-' }}">{{ forecast.julProjectName || '-' }}<span class="presales-chip" *ngIf="isPresalesProject(forecast.julProjectId)" pTooltip="In-pursuit presales deal — not yet won" tooltipPosition="top">Presales</span></span>
        </td>
        <td [ngClass]="{'status-confirmed': forecast.augStatus === 2, 'status-planned': forecast.augStatus === 1, 'available-cell': isAvailable(forecast.augProjectName)}">
          <span [class.available-cell]="isAvailable(forecast.augProjectName)" title="{{ forecast.augProjectName || '-' }}">{{ forecast.augProjectName || '-' }}<span class="presales-chip" *ngIf="isPresalesProject(forecast.augProjectId)" pTooltip="In-pursuit presales deal — not yet won" tooltipPosition="top">Presales</span></span>
        </td>
        <td [ngClass]="{'status-confirmed': forecast.sepStatus === 2, 'status-planned': forecast.sepStatus === 1, 'available-cell': isAvailable(forecast.sepProjectName)}">
          <span [class.available-cell]="isAvailable(forecast.sepProjectName)" title="{{ forecast.sepProjectName || '-' }}">{{ forecast.sepProjectName || '-' }}<span class="presales-chip" *ngIf="isPresalesProject(forecast.sepProjectId)" pTooltip="In-pursuit presales deal — not yet won" tooltipPosition="top">Presales</span></span>
        </td>
        <td [ngClass]="{'status-confirmed': forecast.octStatus === 2, 'status-planned': forecast.octStatus === 1, 'available-cell': isAvailable(forecast.octProjectName)}">
          <span [class.available-cell]="isAvailable(forecast.octProjectName)" title="{{ forecast.octProjectName || '-' }}">{{ forecast.octProjectName || '-' }}<span class="presales-chip" *ngIf="isPresalesProject(forecast.octProjectId)" pTooltip="In-pursuit presales deal — not yet won" tooltipPosition="top">Presales</span></span>
        </td>
        <td [ngClass]="{'status-confirmed': forecast.novStatus === 2, 'status-planned': forecast.novStatus === 1, 'available-cell': isAvailable(forecast.novProjectName)}">
          <span [class.available-cell]="isAvailable(forecast.novProjectName)" title="{{ forecast.novProjectName || '-' }}">{{ forecast.novProjectName || '-' }}<span class="presales-chip" *ngIf="isPresalesProject(forecast.novProjectId)" pTooltip="In-pursuit presales deal — not yet won" tooltipPosition="top">Presales</span></span>
        </td>
        <td [ngClass]="{'status-confirmed': forecast.decStatus === 2, 'status-planned': forecast.decStatus === 1, 'available-cell': isAvailable(forecast.decProjectName)}">
          <span [class.available-cell]="isAvailable(forecast.decProjectName)" title="{{ forecast.decProjectName || '-' }}">{{ forecast.decProjectName || '-' }}<span class="presales-chip" *ngIf="isPresalesProject(forecast.decProjectId)" pTooltip="In-pursuit presales deal — not yet won" tooltipPosition="top">Presales</span></span>
        </td>
        <td *ngIf="canWrite" class="table-cell-actions" (click)="$event.stopPropagation()">
          <div class="table-actions-stack">
            <p-button
              icon="pi pi-pencil"
              (onClick)="showEditDialog(forecast)"
              [text]="true"
              severity="info"
              size="small"
              ariaLabel="Edit forecast" />
            <p-button
              icon="pi pi-trash"
              (onClick)="deleteForecast(forecast)"
              [text]="true"
              severity="danger"
              size="small"
              ariaLabel="Delete forecast" />
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr class="table-empty-row">
        <td colspan="15" class="table-empty-cell">
          <div class="empty-state">
            <div class="empty-icon"><i class="pi pi-inbox"></i></div>
            <p class="empty-message">No forecasts found</p>
            <p class="empty-description">{{ searchText ? 'No results match your search criteria. Try adjusting filters or search.' : 'Click "Add Forecast" to create one.' }}</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
  </div>
</div>

<p-dialog
  [visible]="displayDialog"
  (visibleChange)="displayDialog = $event; !$event && hideDialog()"
  [header]="isEditMode ? 'Edit Forecast' : 'Add Forecast'"
  [modal]="true"
  styleClass="dialog-lg"
  [dismissableMask]="true"
  [closable]="true">

  <div class="p-fluid form-dialog-container form-dialog-form form-dialog-compact">
    <div class="form-row two-columns">
      <div class="field" [class.field-invalid]="fieldTouched['employeeId'] && !selectedForecast.employeeId">
        <label for="employee">Employee *</label>
        <p-select
          id="employee"
          [(ngModel)]="selectedForecast.employeeId"
          (ngModelChange)="onEmployeeChange($event)"
          [options]="employeeOptionsForDialog"
          optionLabel="name"
          optionValue="id"
          placeholder="Select an employee"
          [filter]="true"
          [showClear]="true"
          [disabled]="isEditMode"
          (onBlur)="fieldTouched['employeeId'] = true"
          appendTo="body" />
        <small class="field-error" *ngIf="fieldTouched['employeeId'] && !selectedForecast.employeeId">Employee is required</small>
      </div>
      <div class="field">
        <label for="designation">Designation</label>
        <p-select
          id="designation"
          [(ngModel)]="selectedForecast.designationId"
          [options]="designationOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Select a designation"
          [showClear]="true"
          appendTo="body" [filter]="true" filterPlaceholder="Search…" />
      </div>
    </div>

    <div class="form-row two-columns">
      <div class="field">
        <label for="category">Category</label>
        <p-select
          id="category"
          [(ngModel)]="selectedForecast.categoryId"
          [options]="categoryOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Select a category"
          [showClear]="true"
          appendTo="body" [filter]="true" filterPlaceholder="Search…" />
      </div>
      <div class="field">
        <label for="yearField">Year *</label>
        <p-select
          id="yearField"
          [(ngModel)]="selectedForecast.year"
          [options]="yearOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Select year"
          appendTo="body" />
      </div>
    </div>

    <div class="field grid form-section-full">
      <label class="form-section-label">Monthly Projects</label>
      <div class="form-section-content">
        <div class="grid">
          <div class="col-12 md:col-6 mb-2">
            <div class="flex align-items-center gap-2">
              <label for="janProject" class="block mb-1" style="min-width: 50px;">Jan</label>
              <p-select
                id="janProject"
                [(ngModel)]="selectedForecast.janProjectId"
                (ngModelChange)="selectedForecast.janStatus = undefined"
                [options]="activeProjects"
                optionLabel="name"
                optionValue="id"
                placeholder="Select project"
                [filter]="true"
                [showClear]="true"
                appendTo="body"
                style="flex: 1;" />
              <div *ngIf="selectedForecast.janProjectId" class="flex align-items-center gap-3">
                <div class="flex align-items-center gap-1">
                  <p-checkbox
                    [(ngModel)]="janPlanned"
                    (ngModelChange)="onJanStatusChange($event, 'planned')"
                    binary="true"
                    inputId="janPlanned" />
                  <label for="janPlanned" style="font-size: 0.875rem; cursor: pointer; margin: 0; font-weight: 600; color: #b8860b;">
                    Planned
                  </label>
                </div>
                <div class="flex align-items-center gap-1">
                  <p-checkbox
                    [(ngModel)]="janConfirmed"
                    (ngModelChange)="onJanStatusChange($event, 'confirmed')"
                    binary="true"
                    inputId="janConfirmed" />
                  <label for="janConfirmed" style="font-size: 0.875rem; cursor: pointer; margin: 0; font-weight: 600; color: #0d5d1f;">
                    Confirmed
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-6 mb-2">
            <div class="flex align-items-center gap-2">
              <label for="febProject" class="block mb-1" style="min-width: 50px;">Feb</label>
              <p-select
                id="febProject"
                [(ngModel)]="selectedForecast.febProjectId"
                (ngModelChange)="selectedForecast.febStatus = selectedForecast.febProjectId ? AllocationStatus.Planned : undefined"
                [options]="activeProjects"
                optionLabel="name"
                optionValue="id"
                placeholder="Select project"
                [filter]="true"
                [showClear]="true"
                appendTo="body"
                style="flex: 1;" />
              <div *ngIf="selectedForecast.febProjectId" class="flex align-items-center gap-3">
                <div class="flex align-items-center gap-1">
                  <p-checkbox
                    [(ngModel)]="febPlanned"
                    (ngModelChange)="onFebStatusChange($event, 'planned')"
                    binary="true"
                    inputId="febPlanned" />
                  <label for="febPlanned" style="font-size: 0.875rem; cursor: pointer; margin: 0; font-weight: 600; color: #b8860b;">
                    Planned
                  </label>
                </div>
                <div class="flex align-items-center gap-1">
                  <p-checkbox
                    [(ngModel)]="febConfirmed"
                    (ngModelChange)="onFebStatusChange($event, 'confirmed')"
                    binary="true"
                    inputId="febConfirmed" />
                  <label for="febConfirmed" style="font-size: 0.875rem; cursor: pointer; margin: 0; font-weight: 600; color: #0d5d1f;">
                    Confirmed
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-6 mb-2">
            <div class="flex align-items-center gap-2">
              <label for="marProject" class="block mb-1" style="min-width: 50px;">Mar</label>
              <p-select
                id="marProject"
                [(ngModel)]="selectedForecast.marProjectId"
                (ngModelChange)="selectedForecast.marStatus = undefined"
                [options]="activeProjects"
                optionLabel="name"
                optionValue="id"
                placeholder="Select project"
                [filter]="true"
                [showClear]="true"
                appendTo="body"
                style="flex: 1;" />
              <div *ngIf="selectedForecast.marProjectId" class="flex align-items-center gap-3">
                <div class="flex align-items-center gap-1">
                  <p-checkbox
                    [(ngModel)]="marPlanned"
                    (ngModelChange)="onMarStatusChange($event, 'planned')"
                    binary="true"
                    inputId="marPlanned" />
                  <label for="marPlanned" style="font-size: 0.875rem; cursor: pointer; margin: 0; font-weight: 600; color: #b8860b;">
                    Planned
                  </label>
                </div>
                <div class="flex align-items-center gap-1">
                  <p-checkbox
                    [(ngModel)]="marConfirmed"
                    (ngModelChange)="onMarStatusChange($event, 'confirmed')"
                    binary="true"
                    inputId="marConfirmed" />
                  <label for="marConfirmed" style="font-size: 0.875rem; cursor: pointer; margin: 0; font-weight: 600; color: #0d5d1f;">
                    Confirmed
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-6 mb-2">
            <div class="flex align-items-center gap-2">
              <label for="aprProject" class="block mb-1" style="min-width: 50px;">Apr</label>
              <p-select
                id="aprProject"
                [(ngModel)]="selectedForecast.aprProjectId"
                (ngModelChange)="selectedForecast.aprStatus = undefined"
                [options]="activeProjects"
                optionLabel="name"
                optionValue="id"
                placeholder="Select project"
                [filter]="true"
                [showClear]="true"
                appendTo="body"
                style="flex: 1;" />
              <div *ngIf="selectedForecast.aprProjectId" class="flex align-items-center gap-3">
                <div class="flex align-items-center gap-1">
                  <p-checkbox
                    [(ngModel)]="aprPlanned"
                    (ngModelChange)="onAprStatusChange($event, 'planned')"
                    binary="true"
                    inputId="aprPlanned" />
                  <label for="aprPlanned" style="font-size: 0.875rem; cursor: pointer; margin: 0; font-weight: 600; color: #b8860b;">
                    Planned
                  </label>
                </div>
                <div class="flex align-items-center gap-1">
                  <p-checkbox
                    [(ngModel)]="aprConfirmed"
                    (ngModelChange)="onAprStatusChange($event, 'confirmed')"
                    binary="true"
                    inputId="aprConfirmed" />
                  <label for="aprConfirmed" style="font-size: 0.875rem; cursor: pointer; margin: 0; font-weight: 600; color: #0d5d1f;">
                    Confirmed
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-6 mb-2">
            <div class="flex align-items-center gap-2">
              <label for="mayProject" class="block mb-1" style="min-width: 50px;">May</label>
              <p-select
                id="mayProject"
                [(ngModel)]="selectedForecast.mayProjectId"
                (ngModelChange)="selectedForecast.mayStatus = undefined"
                [options]="activeProjects"
                optionLabel="name"
                optionValue="id"
                placeholder="Select project"
                [filter]="true"
                [showClear]="true"
                appendTo="body"
                style="flex: 1;" />
              <div *ngIf="selectedForecast.mayProjectId" class="flex align-items-center gap-3">
                <div class="flex align-items-center gap-1">
                  <p-checkbox
                    [(ngModel)]="mayPlanned"
                    (ngModelChange)="onMayStatusChange($event, 'planned')"
                    binary="true"
                    inputId="mayPlanned" />
                  <label for="mayPlanned" style="font-size: 0.875rem; cursor: pointer; margin: 0; font-weight: 600; color: #b8860b;">
                    Planned
                  </label>
                </div>
                <div class="flex align-items-center gap-1">
                  <p-checkbox
                    [(ngModel)]="mayConfirmed"
                    (ngModelChange)="onMayStatusChange($event, 'confirmed')"
                    binary="true"
                    inputId="mayConfirmed" />
                  <label for="mayConfirmed" style="font-size: 0.875rem; cursor: pointer; margin: 0; font-weight: 600; color: #0d5d1f;">
                    Confirmed
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-6 mb-2">
            <div class="flex align-items-center gap-2">
              <label for="junProject" class="block mb-1" style="min-width: 50px;">Jun</label>
              <p-select
                id="junProject"
                [(ngModel)]="selectedForecast.junProjectId"
                (ngModelChange)="selectedForecast.junStatus = undefined"
                [options]="activeProjects"
                optionLabel="name"
                optionValue="id"
                placeholder="Select project"
                [filter]="true"
                [showClear]="true"
                appendTo="body"
                style="flex: 1;" />
              <div *ngIf="selectedForecast.junProjectId" class="flex align-items-center gap-3">
                <div class="flex align-items-center gap-1">
                  <p-checkbox
                    [(ngModel)]="junPlanned"
                    (ngModelChange)="onJunStatusChange($event, 'planned')"
                    binary="true"
                    inputId="junPlanned" />
                  <label for="junPlanned" style="font-size: 0.875rem; cursor: pointer; margin: 0; font-weight: 600; color: #b8860b;">
                    Planned
                  </label>
                </div>
                <div class="flex align-items-center gap-1">
                  <p-checkbox
                    [(ngModel)]="junConfirmed"
                    (ngModelChange)="onJunStatusChange($event, 'confirmed')"
                    binary="true"
                    inputId="junConfirmed" />
                  <label for="junConfirmed" style="font-size: 0.875rem; cursor: pointer; margin: 0; font-weight: 600; color: #0d5d1f;">
                    Confirmed
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-6 mb-2">
            <div class="flex align-items-center gap-2">
              <label for="julProject" class="block mb-1" style="min-width: 50px;">Jul</label>
              <p-select
                id="julProject"
                [(ngModel)]="selectedForecast.julProjectId"
                (ngModelChange)="selectedForecast.julStatus = undefined"
                [options]="activeProjects"
                optionLabel="name"
                optionValue="id"
                placeholder="Select project"
                [filter]="true"
                [showClear]="true"
                appendTo="body"
                style="flex: 1;" />
              <div *ngIf="selectedForecast.julProjectId" class="flex align-items-center gap-3">
                <div class="flex align-items-center gap-1">
                  <p-checkbox
                    [(ngModel)]="julPlanned"
                    (ngModelChange)="onJulStatusChange($event, 'planned')"
                    binary="true"
                    inputId="julPlanned" />
                  <label for="julPlanned" style="font-size: 0.875rem; cursor: pointer; margin: 0; font-weight: 600; color: #b8860b;">
                    Planned
                  </label>
                </div>
                <div class="flex align-items-center gap-1">
                  <p-checkbox
                    [(ngModel)]="julConfirmed"
                    (ngModelChange)="onJulStatusChange($event, 'confirmed')"
                    binary="true"
                    inputId="julConfirmed" />
                  <label for="julConfirmed" style="font-size: 0.875rem; cursor: pointer; margin: 0; font-weight: 600; color: #0d5d1f;">
                    Confirmed
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-6 mb-2">
            <div class="flex align-items-center gap-2">
              <label for="augProject" class="block mb-1" style="min-width: 50px;">Aug</label>
              <p-select
                id="augProject"
                [(ngModel)]="selectedForecast.augProjectId"
                (ngModelChange)="selectedForecast.augStatus = undefined"
                [options]="activeProjects"
                optionLabel="name"
                optionValue="id"
                placeholder="Select project"
                [filter]="true"
                [showClear]="true"
                appendTo="body"
                style="flex: 1;" />
              <div *ngIf="selectedForecast.augProjectId" class="flex align-items-center gap-3">
                <div class="flex align-items-center gap-1">
                  <p-checkbox
                    [(ngModel)]="augPlanned"
                    (ngModelChange)="onAugStatusChange($event, 'planned')"
                    binary="true"
                    inputId="augPlanned" />
                  <label for="augPlanned" style="font-size: 0.875rem; cursor: pointer; margin: 0; font-weight: 600; color: #b8860b;">
                    Planned
                  </label>
                </div>
                <div class="flex align-items-center gap-1">
                  <p-checkbox
                    [(ngModel)]="augConfirmed"
                    (ngModelChange)="onAugStatusChange($event, 'confirmed')"
                    binary="true"
                    inputId="augConfirmed" />
                  <label for="augConfirmed" style="font-size: 0.875rem; cursor: pointer; margin: 0; font-weight: 600; color: #0d5d1f;">
                    Confirmed
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-6 mb-2">
            <div class="flex align-items-center gap-2">
              <label for="sepProject" class="block mb-1" style="min-width: 50px;">Sep</label>
              <p-select
                id="sepProject"
                [(ngModel)]="selectedForecast.sepProjectId"
                (ngModelChange)="selectedForecast.sepStatus = undefined"
                [options]="activeProjects"
                optionLabel="name"
                optionValue="id"
                placeholder="Select project"
                [filter]="true"
                [showClear]="true"
                appendTo="body"
                style="flex: 1;" />
              <div *ngIf="selectedForecast.sepProjectId" class="flex align-items-center gap-3">
                <div class="flex align-items-center gap-1">
                  <p-checkbox
                    [(ngModel)]="sepPlanned"
                    (ngModelChange)="onSepStatusChange($event, 'planned')"
                    binary="true"
                    inputId="sepPlanned" />
                  <label for="sepPlanned" style="font-size: 0.875rem; cursor: pointer; margin: 0; font-weight: 600; color: #b8860b;">
                    Planned
                  </label>
                </div>
                <div class="flex align-items-center gap-1">
                  <p-checkbox
                    [(ngModel)]="sepConfirmed"
                    (ngModelChange)="onSepStatusChange($event, 'confirmed')"
                    binary="true"
                    inputId="sepConfirmed" />
                  <label for="sepConfirmed" style="font-size: 0.875rem; cursor: pointer; margin: 0; font-weight: 600; color: #0d5d1f;">
                    Confirmed
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-6 mb-2">
            <div class="flex align-items-center gap-2">
              <label for="octProject" class="block mb-1" style="min-width: 50px;">Oct</label>
              <p-select
                id="octProject"
                [(ngModel)]="selectedForecast.octProjectId"
                (ngModelChange)="selectedForecast.octStatus = undefined"
                [options]="activeProjects"
                optionLabel="name"
                optionValue="id"
                placeholder="Select project"
                [filter]="true"
                [showClear]="true"
                appendTo="body"
                style="flex: 1;" />
              <div *ngIf="selectedForecast.octProjectId" class="flex align-items-center gap-3">
                <div class="flex align-items-center gap-1">
                  <p-checkbox
                    [(ngModel)]="octPlanned"
                    (ngModelChange)="onOctStatusChange($event, 'planned')"
                    binary="true"
                    inputId="octPlanned" />
                  <label for="octPlanned" style="font-size: 0.875rem; cursor: pointer; margin: 0; font-weight: 600; color: #b8860b;">
                    Planned
                  </label>
                </div>
                <div class="flex align-items-center gap-1">
                  <p-checkbox
                    [(ngModel)]="octConfirmed"
                    (ngModelChange)="onOctStatusChange($event, 'confirmed')"
                    binary="true"
                    inputId="octConfirmed" />
                  <label for="octConfirmed" style="font-size: 0.875rem; cursor: pointer; margin: 0; font-weight: 600; color: #0d5d1f;">
                    Confirmed
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-6 mb-2">
            <div class="flex align-items-center gap-2">
              <label for="novProject" class="block mb-1" style="min-width: 50px;">Nov</label>
              <p-select
                id="novProject"
                [(ngModel)]="selectedForecast.novProjectId"
                (ngModelChange)="selectedForecast.novStatus = undefined"
                [options]="activeProjects"
                optionLabel="name"
                optionValue="id"
                placeholder="Select project"
                [filter]="true"
                [showClear]="true"
                appendTo="body"
                style="flex: 1;" />
              <div *ngIf="selectedForecast.novProjectId" class="flex align-items-center gap-3">
                <div class="flex align-items-center gap-1">
                  <p-checkbox
                    [(ngModel)]="novPlanned"
                    (ngModelChange)="onNovStatusChange($event, 'planned')"
                    binary="true"
                    inputId="novPlanned" />
                  <label for="novPlanned" style="font-size: 0.875rem; cursor: pointer; margin: 0; font-weight: 600; color: #b8860b;">
                    Planned
                  </label>
                </div>
                <div class="flex align-items-center gap-1">
                  <p-checkbox
                    [(ngModel)]="novConfirmed"
                    (ngModelChange)="onNovStatusChange($event, 'confirmed')"
                    binary="true"
                    inputId="novConfirmed" />
                  <label for="novConfirmed" style="font-size: 0.875rem; cursor: pointer; margin: 0; font-weight: 600; color: #0d5d1f;">
                    Confirmed
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-6 mb-2">
            <div class="flex align-items-center gap-2">
              <label for="decProject" class="block mb-1" style="min-width: 50px;">Dec</label>
              <p-select
                id="decProject"
                [(ngModel)]="selectedForecast.decProjectId"
                (ngModelChange)="selectedForecast.decStatus = undefined"
                [options]="activeProjects"
                optionLabel="name"
                optionValue="id"
                placeholder="Select project"
                [filter]="true"
                [showClear]="true"
                appendTo="body"
                style="flex: 1;" />
              <div *ngIf="selectedForecast.decProjectId" class="flex align-items-center gap-3">
                <div class="flex align-items-center gap-1">
                  <p-checkbox
                    [(ngModel)]="decPlanned"
                    (ngModelChange)="onDecStatusChange($event, 'planned')"
                    binary="true"
                    inputId="decPlanned" />
                  <label for="decPlanned" style="font-size: 0.875rem; cursor: pointer; margin: 0; font-weight: 600; color: #b8860b;">
                    Planned
                  </label>
                </div>
                <div class="flex align-items-center gap-1">
                  <p-checkbox
                    [(ngModel)]="decConfirmed"
                    (ngModelChange)="onDecStatusChange($event, 'confirmed')"
                    binary="true"
                    inputId="decConfirmed" />
                  <label for="decConfirmed" style="font-size: 0.875rem; cursor: pointer; margin: 0; font-weight: 600; color: #0d5d1f;">
                    Confirmed
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button
        label="Reset"
        icon="pi pi-refresh"
        (onClick)="resetForecastForm()"
        severity="secondary"
        [text]="true"
        styleClass="btn-form-reset" />
      <p-button
        label="Cancel"
        icon="pi pi-times"
        (onClick)="hideDialog()"
        severity="secondary"
        [text]="true" />
      <p-button
        label="Save"
        icon="pi pi-check"
        (onClick)="saveForecast()"
        severity="primary" />
    </div>
  </ng-template>
</p-dialog>

<!-- Un-Forecasted Employees Dialog (eligible employees without a forecast row for the selected year) -->
<p-dialog
  [visible]="displayUnforecastedDialog"
  (visibleChange)="displayUnforecastedDialog = $event"
  [modal]="true"
  styleClass="dialog-xl unallocated-employees-dialog"
  [dismissableMask]="true"
  [closable]="true">

  <ng-template pTemplate="header">
    <div class="dialog-header-with-meta">
      <span class="dialog-header-title">Un-Forecasted Employees</span>
      <span class="dialog-header-badge">{{ unforecastedEmployees.length }}</span>
      <span class="dialog-header-period">{{ selectedYear }}</span>
    </div>
  </ng-template>

  <div *ngIf="loadingUnforecasted" class="loading-container">
    <p class="text-muted">Loading un-forecasted employees...</p>
  </div>

  <div *ngIf="!loadingUnforecasted" class="unallocated-dialog-inner">
    <div class="unallocated-table-scroll-holder">
      <p-table
        [value]="unforecastedEmployees"
        [paginator]="true"
        [alwaysShowPaginator]="false"
        [rows]="20"
        [tableStyle]="{ 'min-width': '100%' }"
        styleClass="compact-striped-table unallocated-dialog-table table-flat table-no-xscroll">

        <ng-template pTemplate="header">
          <tr>
            <th class="unallocated-col-name">Employee Name</th>
            <th class="unallocated-col-email">Email</th>
            <th class="unallocated-col-designation">Designation</th>
            <th class="unallocated-col-category">Category</th>
            <th class="unallocated-col-service">Service Group</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-employee>
          <tr>
            <td class="unallocated-cell-name">
              <button type="button" class="unallocated-name-link"
                (click)="openAddForecastForEmployee(employee)"
                [pTooltip]="'Add forecast for ' + employee.name"
                tooltipPosition="top">{{ employee.name }}</button>
            </td>
            <td class="unallocated-cell-email"><span class="unallocated-cell-text" [pTooltip]="(employee.email || '-')" tooltipPosition="top">{{ employee.email || '-' }}</span></td>
            <td class="unallocated-cell-designation"><span class="unallocated-cell-text" [pTooltip]="(employee.designationName || '-')" tooltipPosition="top">{{ employee.designationName || '-' }}</span></td>
            <td class="unallocated-cell-category"><span class="unallocated-cell-text" [pTooltip]="(employee.categoryName || '-')" tooltipPosition="top">{{ employee.categoryName || '-' }}</span></td>
            <td class="unallocated-cell-service"><span class="unallocated-cell-text" [pTooltip]="(employee.serviceGroupName || '-')" tooltipPosition="top">{{ employee.serviceGroupName || '-' }}</span></td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5" class="text-center empty-message-text p-4">
              All eligible employees already have a forecast row for {{ selectedYear }}.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      label="Close"
      icon="pi pi-times"
      (onClick)="hideUnforecastedDialog()"
      severity="secondary" />
    <p-button
      label="Export Excel"
      icon="pi pi-file-excel"
      (onClick)="exportUnforecastedToExcel()"
      severity="success"
      [disabled]="unforecastedEmployees.length === 0" />
  </ng-template>
</p-dialog>
